export default __webpack_public_path__ + "static/media/air-export-light.10adf7bb.svg";